import gql from "graphql-tag";

export const GET_SERVICE_REQUESTS = gql`
  query ConsumerServiceRequests($args: GetServiceRequestsInput!) {
    consumerServiceRequests(args: $args) {
      total
      serviceRequests {
        id
        referenceNumber
        vehicleId
        vehicle {
          id
          licencePlate
        }
        serviceType
        serviceCategory
        issues {
          issueType
          description
          images
        }
        mileage
        dueService
        comments
        accidentDate
        accidentTime
        accidentLocation
        policeReportUrl
        additionalDetails {
          questionId
          question
          answer
          answerType
          options
          selectedOptions
          files
          isMandatory
        }
        customer {
          id
        }
        businessCustomer {
          id
        }
        status
        createdAt
        updatedAt
        createdBy
        updatedBy
        tenantId
        organisationId
        branchId
        reviewedBy
        reviewedAt
        declineReason
        serviceProviderId
        serviceProviderName
        appointmentDate
        estimatedCompletionDate
        estimatedCost
        actualCost
        jobSheet {
          task
          taskDescription
          imageUrl
          cost
        }
        damages
        notes {
          note
          createdBy
          createdByName
          createdAt
          isCustomerVisible
        }
        createdVehicleServiceId
        createdVehicleServiceRef
        vehicleService {
          id
          referenceNumber
          status
        }
      }
    }
  }
`;

export const GET_SERVICE_REQUEST = gql`
  query ServiceRequest($serviceRequestId: ID!) {
    serviceRequest(serviceRequestId: $serviceRequestId) {
      id
      referenceNumber
      vehicleId
      vehicle {
        id
        licencePlate
        make
        model
        year
      }
      serviceType
      serviceCategory
      issues {
        issueType
        description
        images
      }
      mileage
      dueService
      comments
      accidentDate
      accidentTime
      accidentLocation
      policeReportUrl
      additionalDetails {
        questionId
        question
        answer
        answerType
        options
        selectedOptions
        files
        isMandatory
      }
      customer {
        id
      }
      businessCustomer {
        id
      }
      status
      consumerApproved
      isAppointmentDateRequestModified
      createdAt
      updatedAt
      createdBy
      updatedBy
      tenantId
      organisationId
      branchId
      reviewedBy
      reviewedAt
      declineReason
      serviceProviderId
      serviceProviderName
      appointmentDate
      estimatedCompletionDate
      estimatedCost
      actualCost
      jobSheet {
        task
        taskDescription
        imageUrl
        cost
        approved
      }
      damages
      notes {
        note
        createdBy
        createdByName
        createdAt
        isCustomerVisible
      }
      createdVehicleServiceId
      createdVehicleServiceRef
      vehicleService {
        id
        referenceNumber
        status
        serviceType
        serviceCategory
        appointmentDate
        startDate
        endDate
        completionDate
        serviceProviderName
        serviceProviderAddress {
          street
          city
          fullAddress
          state
          country
          zipcode
        }
        description
        totalExpenses
        odometerReading
        jobSheet {
          id
          name
          description
          cost
        }
        jobSheetStatus
      }
    }
  }
`;










